import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import ChangeDispatchAddressMobile from './dispatchAddress/ChangeDispatchAddressMobile';
import ChangeDispatchDateMobile from './dispatchDate/ChangeDispatchDateMobile';
import AuthorizeThirdMobile from './authorizeThird/AuthorizeThirdMobile';

import useSetMessage from '../../../../../../../helpers/tickets/SelfServiceHook';
import GoldSilverPaymentFormMobile from './goldSilverPayment/GoldSilverPaymentFormMobile';
import BadStateMobile from './badState/BadStateMobile';
import NotWorkingMobile from './notWorking/NotWorkingMobile';
import AnotherProductMobile from './anotherProduct/AnotherProductMobile';
import { PURCHASE_ROUTE } from '../../../../../../../constants/Routes';
import useQuery from '../../../../../../../hooks/useQuery/useQuery';
import ArrivedIncompleteMobile from './arrivedIncomplete/ArrivedIncompleteMobile';
import AssembleProductMobile from './assembleProduct/AssembleProductMobile';
import CancelPurchaseMobile from './cancelPurchase/CancelPurchaseMobile';
import ChangeProductMobile from './changeProduct/ChangeProductMobile';
import CancellationStatus from '../../forms/cancellationStatus/CancellationStatus';
import AlarmInProductMobile from './alarmInProduct/AlarmInProductMobile';
import NotReceivedMobile from './notReceived/NotReceivedMobile';

const FormsViews = ({ ...props }) => {
  const { product } = props;
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const query = useQuery();
  const { state } = location;
  const [data, setData] = useState({});
  const [currentMotiveId, setCurrentMotiveId] = useState('');
  const [currentProduct, setCurrentProduct] = useState({});
  const [motiveId, setMotiveId] = useState('');
  const profile = useSelector(
    (innerState) => innerState.profileReducer.profile,
  );
  const {
    ticketNoProductStatus,
    selfServiceStatus,
    validationStatus,
    validation,
    ticket,
  } = useSelector((innerState) => innerState.ticketReducer);

  useEffect(() => {
    useSetMessage(ticketNoProductStatus, data, dispatch, history);
  }, [ticketNoProductStatus, data]);

  useEffect(() => {
    useSetMessage(selfServiceStatus, data, dispatch, history);
  }, [selfServiceStatus, data]);

  const dataToShow = (innerData) => {
    setData(innerData);
  };

  useEffect(() => {
    const queryMotiveId = query.get('motiveId');
    if (queryMotiveId) setMotiveId(queryMotiveId);
  }, []);

  useEffect(() => {
    const validMotiveId = state?.motiveId || motiveId;
    const validProduct = state?.product || product;

    if (!validMotiveId || !validProduct) history.push(PURCHASE_ROUTE);

    setCurrentMotiveId(validMotiveId);
    setCurrentProduct(validProduct);
  }, []);

  useEffect(() => {
    if (ticketNoProductStatus === 'succeded')
      dataToShow({ motiveId, message: ticket.ticketId, noProduct: true });
  }, [ticketNoProductStatus]);

  return (
    <React.Fragment>
      {currentMotiveId === '2' && (
        <NotReceivedMobile
          motiveId={currentMotiveId}
          orderId={currentProduct?.orderId?.toString()}
          sku={currentProduct?.sku}
          product={currentProduct}
          profile={profile}
          type={state.type}
          selfServiceStatus={selfServiceStatus}
          validationStatus={validationStatus}
          validation={validation}
          onData={dataToShow}
        />
      )}
      {currentMotiveId === '28' && (
        <AuthorizeThirdMobile
          motiveId={currentMotiveId}
          orderId={currentProduct?.orderId?.toString()}
          sku={currentProduct?.sku}
          product={currentProduct}
          profile={profile}
          type={state.type}
          selfServiceStatus={selfServiceStatus}
          validationStatus={validationStatus}
          validation={validation}
          onData={dataToShow}
        />
      )}
      {currentMotiveId === '10' && (
        <ChangeDispatchAddressMobile
          motiveId={currentMotiveId}
          orderId={currentProduct?.orderId}
          sku={currentProduct?.sku}
          product={currentProduct}
          profile={profile}
          selfServiceStatus={selfServiceStatus}
          onData={dataToShow}
        />
      )}
      {currentMotiveId === '1' && (
        <ChangeDispatchDateMobile
          motiveId={currentMotiveId}
          orderId={currentProduct?.orderId}
          sku={currentProduct?.sku}
          product={currentProduct}
          profile={profile}
          selfServiceStatus={selfServiceStatus}
          onData={dataToShow}
        />
      )}
      {currentMotiveId === '29' && (
        <GoldSilverPaymentFormMobile
          motiveId={currentMotiveId}
          type={state.type}
          product={currentProduct}
          profile={profile}
          onData={dataToShow}
        />
      )}
      {currentMotiveId === '6' && (
        <BadStateMobile
          motiveId={currentMotiveId}
          type={state.type}
          product={currentProduct}
          profile={profile}
          onData={dataToShow}
        />
      )}
      {currentMotiveId === '4' && (
        <ArrivedIncompleteMobile
          motiveId={currentMotiveId}
          type={state.type}
          product={state.product}
          profile={profile}
          onData={dataToShow}
        />
      )}
      {currentMotiveId === '3' && (
        <AnotherProductMobile
          motiveId={currentMotiveId}
          type={state.type}
          product={currentProduct}
          profile={profile}
          onData={dataToShow}
        />
      )}
      {currentMotiveId === '5' && (
        <NotWorkingMobile
          motiveId={currentMotiveId}
          type={state.type}
          product={state.product}
          profile={profile}
          onData={dataToShow}
        />
      )}
      {currentMotiveId === '9' && (
        <AssembleProductMobile
          motiveId={currentMotiveId}
          type={state.type}
          product={state.product}
          profile={profile}
          onData={dataToShow}
        />
      )}
      {currentMotiveId === '7' && (
        <CancelPurchaseMobile
          motiveId={currentMotiveId}
          type={state.type}
          product={state.product}
          profile={profile}
          onData={dataToShow}
        />
      )}
      {currentMotiveId === '35' && (
        <ChangeProductMobile
          motiveId={currentMotiveId}
          type={10}
          product={state.product}
          orderId={currentProduct?.orderId?.toString()}
          sku={currentProduct?.sku}
          profile={profile}
          validationStatus={validationStatus}
          validation={validation}
          onData={dataToShow}
        />
      )}
      {currentMotiveId === '37' && (
        <AlarmInProductMobile
          motiveId={currentMotiveId}
          type={2}
          product={state.product}
          orderId={currentProduct?.orderId?.toString()}
          sku={currentProduct?.sku}
          profile={profile}
          validationStatus={validationStatus}
          validation={validation}
          onData={dataToShow}
        />
      )}
      {motiveId === '11' && <CancellationStatus mobile={true} />}
    </React.Fragment>
  );
};

FormsViews.propTypes = {
  product: PropTypes.object,
};

export default FormsViews;
